import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./OrderTracking.css";

const OrderTracking = () => {
  const { orderNumber: urlOrderNumber } = useParams();
  const navigate = useNavigate();

  const [orderNumber, setOrderNumber] = useState("");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

  useEffect(() => {
    if (!urlOrderNumber) return;

    setOrderNumber(urlOrderNumber);
    fetchOrder(urlOrderNumber);
  }, [urlOrderNumber]);

  const fetchOrder = async (number) => {
    try {
      setLoading(true);
      setError("");
      setOrder(null);

      const res = await axios.get(
        `${API_URL}/orders/track/${number}`
      );

      if (res.data.success) {
        setOrder(res.data.order);
      } else {
        setError("Order not found");
      }
    } catch (err) {
      console.error(err);
      setError("Failed to fetch order");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!orderNumber.trim()) {
      setError("Enter order number");
      return;
    }

    navigate(`/track/${orderNumber}`);
  };

  const formatPrice = (p) =>
    `₹${parseFloat(p).toLocaleString("en-IN")}`;

  return (
    <div className="tracking-container">

      <h1>📦 Track Order</h1>

      <form onSubmit={handleSubmit} className="search-box">
        <input
          value={orderNumber}
          onChange={(e) => setOrderNumber(e.target.value)}
          placeholder="Enter Order Number"
        />
        <button>Track</button>
      </form>

      {loading && <p>Loading...</p>}

      {error && <p className="error">{error}</p>}

      {order && (
        <div className="order-card">

          <h3>Order #{order.orderNumber}</h3>

          <p>Status: <b>{order.orderStatus}</b></p>
          <p>Total: {formatPrice(order.totalPrice)}</p>

          <h4>Items:</h4>

          {order.items.map((item, i) => (
            <div key={i} className="item">
              <p>{item.name}</p>
              <p>{item.quantity} × {formatPrice(item.price)}</p>
            </div>
          ))}

          <button onClick={() => navigate("/")}>
            Back Home
          </button>

        </div>
      )}
    </div>
  );
};

export default OrderTracking;